import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { HttpService } from "../../components/services/HttpService";
import { AppointmentActions } from "../actions/AppointmentActions";
import { AppoinitmentType } from "../types/AppoinitmentType";
import { BackDropActions } from "../actions/BackDropActions";
import { AlertActions } from "../actions/AlertActions";

function* bookAppointment(action) {
  try {
    var payload = {
        "id": "",
        "consultationType": action.data.consultationType,
        "description": action.data.description,
        "startDateTime": action.data.startDateTime,
        "endDateTime": action.data.endDateTime?action.data.endDateTime:'',
        "patientId": action.data.patientId,
        "doctorId": action.data.doctorId
      }
    yield put(BackDropActions.start());
    const response = yield call(HttpService.post, "/appointment/create", payload);
    if(response.status==="SUCCESS"){
      yield put(AppointmentActions.updateSuccess(response.result));
      yield put(BackDropActions.end());
      yield put(AlertActions.success(response.message));
    }else{
      yield put(AppointmentActions.failiureHandler(response.result.description));
    }
  } catch (e) {
    yield put(AppointmentActions.failiureHandler(e));
  }
}

function* cancelAppointment(action) {
  try {
    var payload = action.data;
    yield put(BackDropActions.start());
    const response = yield call(HttpService.get, "/appointment/cancel?appointmentId="+action.data);
    if(response.status==="SUCCESS"){
      yield put(AppointmentActions.updateSuccess(response.result));
      yield put(BackDropActions.end());
      yield put(AlertActions.success(response.message));
    }else{
      yield put(AppointmentActions.failiureHandler(response.result.description));
    }
  } catch (e) {
    yield put(AppointmentActions.failiureHandler(e));
  }
}

function* checkInAppointment(action) {
  try {
    yield put(BackDropActions.start());
    const response = yield call(HttpService.put, "/appointment/checkIn?appointmentId="+action.id);
    if(response.status==="SUCCESS"){
      yield put(BackDropActions.end());
      yield put(AlertActions.success(response.message));
    }else{
      yield put(AppointmentActions.failiureHandler(response.result.description));
    }
  } catch (e) {
    yield put(AppointmentActions.failiureHandler(e));
  }
}

function* reScheduleAppointment(action) {
  try {
    var payload = {
      "id": action.data.id,
      "consultationType": action.data.consultationType,
      "description": action.data.description,
      "startDateTime": action.data.startDateTime,
      "endDateTime": action.data.endDateTime?action.data.endDateTime:'',
      "patientId": action.data.patientId,
      "doctorId": action.data.doctorId
    }
    yield put(BackDropActions.start());
    const response = yield call(HttpService.post, "/appointment/reschedule", payload);
    if(response.status==="SUCCESS"){
      yield put(BackDropActions.end());
      yield put(AlertActions.success(response.message));
      yield put(AppointmentActions.updateSuccess(response.result));
    }else{
      yield put(AppointmentActions.errorInBookingAppointment(response.result.description));
      yield put(AppointmentActions.failiureHandler(response.result.description));
    }
  } catch (e) {
    yield put(AppointmentActions.failiureHandler(e));
  }
}

function* updateAppointment(action) {
  try {
    var payload = {
      "id": action.data.id,
      "description": action.data.description,
      "status": action.data.status
    }
    yield put(BackDropActions.start());
    const response = yield call(HttpService.post, "/appointment/update", payload);
    if(response.status==="SUCCESS"){
      yield put(BackDropActions.end());
      yield put(AlertActions.success(response.message));
      yield put(AppointmentActions.updateSuccess(response.result));
    }else{
      yield put(AppointmentActions.errorInBookingAppointment(response.description));
      yield put(AppointmentActions.failiureHandler(response.result.description));
    }
  } catch (e) {
    yield put(AppointmentActions.failiureHandler(e));
  }
}

function* getAllAppointment(action) {
  try {
    var payload = {
      "id": action.data.id?action.data.id:'',
      "startDateTime": action.data.startDateTime?action.data.startDateTime:'',
      "endDateTime": action.data.endDateTime?action.data.endDateTime:'',
      "status": action.data.status?action.data.status:[],
      "doctorId": action.data.doctorId?action.data.doctorId:[],
      "patientId": action.data.patientId?action.data.patientId:[],
      "consultationType": action.data.consultationType?action.data.consultationType:[]
    }
    yield put(BackDropActions.start());
    const response = yield call(HttpService.post, "/appointment/all", payload);
    if(response.status==="SUCCESS"){
      yield put(AppointmentActions.getAllSuccess(response.result));
      yield put(AppointmentActions.successHandler(response.result));
    }else{
      yield put(AppointmentActions.failiureHandler(response.result.description));
    }
  } catch (e) {
    yield put(AppointmentActions.failiureHandler(e));
  }
}

function* getAllTodayAppointment(action) {
  try {
    var payload = {
      "id": action.data.id?action.data.id:'',
      "startDateTime": action.data.startDateTime?action.data.startDateTime:'',
      "endDateTime": action.data.endDateTime?action.data.endDateTime:'',
      "status": action.data.status?action.data.status:[],
      "doctorId": action.data.doctorId?action.data.doctorId:[],
      "patientId": action.data.patientId?action.data.patientId:[],
      "consultationType": action.data.consultationType?action.data.consultationType:[]
    }
    yield put(BackDropActions.start());
    const response = yield call(HttpService.post, "/appointment/today/all", payload);
    if(response.status==="SUCCESS"){
      yield put(AppointmentActions.getAllSuccess(response.result));
      yield put(AppointmentActions.successHandler(response.result));
    }else{
      yield put(AppointmentActions.failiureHandler(response.result.description));
    }
  } catch (e) {
    yield put(AppointmentActions.failiureHandler(e));
  }
}

function* getAllPastAppointment(action) {
  try {
    var payload = {
      "id": action.data.id?action.data.id:'',
      "startDateTime": action.data.startDateTime?action.data.startDateTime:'',
      "endDateTime": action.data.endDateTime?action.data.endDateTime:'',
      "status": action.data.status?action.data.status:[],
      "doctorId": action.data.doctorId?action.data.doctorId:[],
      "patientId": action.data.patientId?action.data.patientId:[],
      "consultationType": action.data.consultationType?action.data.consultationType:[]
    }
    yield put(BackDropActions.start());
    const response = yield call(HttpService.post, "/appointment/past/all", payload);
    if(response.status==="SUCCESS"){
      yield put(AppointmentActions.getAllSuccess(response.result));
      yield put(AppointmentActions.successHandler(response.result));
    }else{
      yield put(AppointmentActions.failiureHandler(response.result.description));
    }
  } catch (e) {
    yield put(AppointmentActions.failiureHandler(e));
  }
}

function* getAllFutureAppointment(action) {
  try {
    var payload = {
      "id": action.data.id?action.data.id:'',
      "startDateTime": action.data.startDateTime?action.data.startDateTime:'',
      "endDateTime": action.data.endDateTime?action.data.endDateTime:'',
      "status": action.data.status?action.data.status:[],
      "doctorId": action.data.doctorId?action.data.doctorId:[],
      "patientId": action.data.patientId?action.data.patientId:[],
      "consultationType": action.data.consultationType?action.data.consultationType:[]
    }
    yield put(BackDropActions.start());
    const response = yield call(HttpService.post, "/appointment/future/all", payload);
    if(response.status==="SUCCESS"){
      yield put(AppointmentActions.getAllSuccess(response.result));
      yield put(AppointmentActions.successHandler(response.result));
    }else{
      yield put(AppointmentActions.failiureHandler(response.result.description));
    }
  } catch (e) {
    yield put(AppointmentActions.failiureHandler(e));
  }
}

function* getAllTomorrowAppointment(action) {
  try {
    var payload = {
      "id": action.data.id?action.data.id:'',
      "startDateTime": action.data.startDateTime?action.data.startDateTime:'',
      "endDateTime": action.data.endDateTime?action.data.endDateTime:'',
      "status": action.data.status?action.data.status:[],
      "doctorId": action.data.doctorId?action.data.doctorId:[],
      "patientId": action.data.patientId?action.data.patientId:[],
      "consultationType": action.data.consultationType?action.data.consultationType:[]
    }
    yield put(BackDropActions.start());
    const response = yield call(HttpService.post, "/appointment/tomorrow/all", payload);
    if(response.status==="SUCCESS"){
      yield put(AppointmentActions.getAllSuccess(response.result));
      yield put(AppointmentActions.successHandler(response.result));
    }else{
      yield put(AppointmentActions.failiureHandler(response.result.description));
    }
  } catch (e) {
    yield put(AppointmentActions.failiureHandler(e));
  }
}

function* getAllWeeklyAppointment(action) {
  try {
    var payload = {
      "id": action.data.id?action.data.id:'',
      "startDateTime": action.data.startDateTime?action.data.startDateTime:'',
      "endDateTime": action.data.endDateTime?action.data.endDateTime:'',
      "status": action.data.status?action.data.status:[],
      "doctorId": action.data.doctorId?action.data.doctorId:[],
      "patientId": action.data.patientId?action.data.patientId:[],
      "consultationType": action.data.consultationType?action.data.consultationType:[]
    }
    yield put(BackDropActions.start());
    const response = yield call(HttpService.post, "/appointment/weekly/all", payload);
    if(response.status==="SUCCESS"){
      yield put(AppointmentActions.getAllSuccess(response.result));
      yield put(AppointmentActions.successHandler(response.result));
    }else{
      yield put(AppointmentActions.failiureHandler(response.result.description));
    }
  } catch (e) {
    yield put(AppointmentActions.failiureHandler(e));
  }
}

function* blockTIme(action) {
  try {
    var payload = {
      "startDateTime": action.data.startDateTime,
      "endDateTime": action.data.endDateTime,
      "doctorId": action.data.doctorId
    }
    yield put(BackDropActions.start());
    const response = yield call(HttpService.post, "/appointment/block/time", payload);
    if(response.status==="SUCCESS"){
      yield put(AppointmentActions.updateSuccess(response.result));
      yield put(BackDropActions.end());
      yield put(AlertActions.success(response.message));
    }else{
      yield put(AppointmentActions.failiureHandler(response.result.description));
    }
  } catch (e) {
    yield put(AppointmentActions.failiureHandler(e));
  }
}

function* getAppointmentById(action) {
  try {
    yield put(BackDropActions.start());
    const response = yield call(HttpService.get, "/appointment/"+action.id);
    if(response.status==="SUCCESS"){
      yield put(AppointmentActions.getByIdSuccess(response.result));
      yield put(AppointmentActions.successHandler(response.result));
    }else{
      yield put(AppointmentActions.failiureHandler(response.result.description));
    }
  } catch (e) {
    yield put(AppointmentActions.failiureHandler(e));
  }
}


function* appointmentSuceessHandler(action){
  try {
    yield put(BackDropActions.end());
    yield put(AlertActions.success(action.data.message));
  } catch (e) {
    yield put(AlertActions.error(e));
  }
}

function* appointmentErrorHandler(action){
  try {
    yield put(BackDropActions.end());
    yield put(AlertActions.error(action.message));
  } catch (e) {
    yield put(AlertActions.error(e));
  }
}




function* appointmentSaga() {
  yield takeEvery(AppoinitmentType.APPOINTMENT_COMMON_SUCCESS, appointmentSuceessHandler);
  yield takeEvery(AppoinitmentType.APPOINTMENT_COMMON_FAILIURE, appointmentErrorHandler);
  yield takeEvery(AppoinitmentType.BOOK_APPOINTMENT_REQUEST, bookAppointment);
  yield takeEvery(AppoinitmentType.UPDATE_APPOINTMENT_REQUEST, updateAppointment);
  yield takeEvery(AppoinitmentType.CANCEL_APPOINTMENT_REQUEST, cancelAppointment);
  yield takeEvery(AppoinitmentType.RESCHEDULE_APPOINTMENT_REQUEST, reScheduleAppointment);
  yield takeEvery(AppoinitmentType.GET_ALL_APPOINTMENT_REQUEST, getAllAppointment);
  yield takeEvery(AppoinitmentType.GET_ALL_TODAY_APPOINTMENT_REQUEST, getAllTodayAppointment);
  yield takeEvery(AppoinitmentType.GET_ALL_PAST_APPOINTMENT_REQUEST, getAllPastAppointment);
  yield takeEvery(AppoinitmentType.GET_ALL_FUTRUE_APPOINTMENT_REQUEST, getAllFutureAppointment);
  yield takeEvery(AppoinitmentType.GET_ALL_TOMORROW_APPOINTMENT_REQUEST, getAllTomorrowAppointment);
  yield takeEvery(AppoinitmentType.GET_ALL_WEEKLY_APPOINTMENT_REQUEST, getAllWeeklyAppointment);
  yield takeEvery(AppoinitmentType.GET_APPOINTMENT_BY_ID_REQUEST, getAppointmentById); 
  yield takeEvery(AppoinitmentType.BLOCK_APPOINTMENT_REQUEST, blockTIme); 
  yield takeEvery(AppoinitmentType.CHECK_IN_PATIENT_REQUEST,checkInAppointment); 
  
}


export default appointmentSaga;
